import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "index_top"
};
const _hoisted_3 = {
  class: "top_search"
};
const _hoisted_4 = {
  class: "top_mess"
};
const _hoisted_5 = {
  class: "index_pro"
};
const _hoisted_6 = {
  class: "pro_show"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "index_pro"
};
const _hoisted_9 = {
  class: "pro_show"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "goClass"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_notice_bar = _resolveComponent("van-notice-bar");
  const _component_van_search = _resolveComponent("van-search");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_swipe, {
    class: "index_banner",
    autoplay: 3000,
    "indicator-color": "white"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.banner, (item, key) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: key
      }, {
        default: _withCtx(() => [_createVNode(_component_router_link, {
          to: item.link
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: item.img,
            width: "100%"
          }, null, 8, _hoisted_1)]),
          _: 2
        }, 1032, ["to"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _createVNode(_component_van_notice_bar, {
    "left-icon": "volume-o",
    class: "index_notice",
    mode: "link",
    scrollable: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Notice, (item, key) => {
      return _openBlock(), _createElementBlock("span", {
        key: key
      }, [_createVNode(_component_router_link, {
        to: "/news/show?id=" + item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
        _: 2
      }, 1032, ["to"])]);
    }), 128))]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "logo"
  }, [_createElementVNode("img", {
    src: "/static/logo.png"
  })], -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_search, {
    modelValue: $setup.keywords,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.keywords = $event),
    placeholder: "请输入搜索关键词",
    onSearch: $setup.goSearch,
    shape: "round"
  }, null, 8, ["modelValue", "onSearch"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
    to: "news"
  }, {
    default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("img", {
      src: "/static/ico_mess.png",
      width: "100%"
    }, null, -1)])),
    _: 1
  })])]), _createElementVNode("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "class_title"
  }, "新品推荐", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_swipe, {
    autoplay: 3000,
    "show-indicators": false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsGoods, (item, key) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: key
      }, {
        default: _withCtx(() => [_createVNode(_component_router_link, {
          to: item.link
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: item.img,
            width: "100%"
          }, null, 8, _hoisted_7)]),
          _: 2
        }, 1032, ["to"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_8, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "class_title"
  }, "促销产品", -1)), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_swipe, {
    autoplay: 3000,
    "show-indicators": false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recGoods, (item, key) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: key
      }, {
        default: _withCtx(() => [_createVNode(_component_router_link, {
          to: item.link
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: item.img
          }, null, 8, _hoisted_10)]),
          _: 2
        }, 1032, ["to"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_router_link, {
    to: "/goods"
  }, {
    default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("订货进入菜单")])),
    _: 1
  })])], 64);
}